import { useTranslation } from 'react-i18next';
import { useFetcher } from 'react-router';
import type { FetcherData } from 'types';

import ErrorIcon from '~/assets/icons/Error';
import { Button } from '~/components/Button';
import TextInput from '~/components/Form/TextInput';

import { authButtonClassName, authInputClassName } from '../AuthDialog';
import AuthPanel from '../AuthPanel';

export default function ForgotPasswordScreen() {
  const fetcher = useFetcher<FetcherData>();
  const { t } = useTranslation();

  const errors = fetcher.data?.errors;
  const success = fetcher.data?.success;
  const submitting = fetcher.state === 'submitting';

  return (
    <>
      <p className="text-center font-body text-sm text-grey-read">
        {t('login.stageForgotPassword.subHeading')}
      </p>
      <fetcher.Form
        action="/bolt/reset-password/"
        className="w-full"
        method="post"
      >
        <AuthPanel>
          <TextInput
            backgroundTheme="light"
            className={authInputClassName}
            error={errors?.email ? t('login.emailFormatError') : undefined}
            id="password-reset-email"
            name="email"
            placeholder={t('login.emailAddress')}
            type="email"
          />
          <Button
            className={authButtonClassName}
            variant={success ? 'disabled' : 'forest'}
            disabled={success}
          >
            {submitting
              ? t('login.stageForgotPassword.resetting')
              : t('login.stageForgotPassword.resetButton')}
          </Button>
          {errors?.notFound && <AccountNotFoundMessage />}
          {success && (
            <p className="text-center font-body text-base">
              {t('login.stageForgotPassword.successMessage')}
            </p>
          )}
        </AuthPanel>
      </fetcher.Form>
    </>
  );
}

function AccountNotFoundMessage() {
  const { t } = useTranslation();

  return (
    <div className="flex h-5 flex-row content-center items-center gap-1">
      <ErrorIcon />
      <p className="text-xs font-bold text-red-600">
        {t('login.stageForgotPassword.noAccountError')}
      </p>
    </div>
  );
}
